import React, { useEffect, useState } from 'react'
import CustomLoader from '../../CustomComponents/loader/CustomLoader'
import HttpClient from '../../utils/HttpClient'
import toast from 'react-hot-toast'
import DataTable from 'react-data-table-component'
import EditDeleteIcon from '../../CustomComponents/EditDeleteIcon'
import moment from 'moment'
import { DeleteConfirmModal } from '../../CustomComponents/DeleteConfirmModal';
import { ImCross } from 'react-icons/im';
const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "35px",
    fontWeight: "bold"

}
const customStyles = {
    rows: {
        style: {
            minHeight: '24px', // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '18px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#cee0eb', // set the background color for head cells
        },
    },

};

const CompanyType = () => {
    const [typeOfCompany, settypeOfCompany] = useState("")
    const [typeOfCompanyID, settypeOfCompanyID] = useState("")
    const [AllData, setAllData] = useState([]);
    const [isLoading, setisLoading] = useState(false)
    const [isEdit, setisEdit] = useState(false);
    // console.log(typeOfCompany, "ddd")

    //Add type
    const handleSubmit = async (e) => {
        e.preventDefault()
        setisLoading(true)
        const data = {
            "type": typeOfCompany
        }
        const res = await HttpClient.requestData("add-companyType", "POST", data)
        if (typeOfCompany !== "") {
            if (res && res?.status) {
                setisLoading(false)
                settypeOfCompany('')
                toast.success('Data submitted')
                getTypeOfCompanies()
            }
            else {
                setisLoading(false);
                toast.error('Something is wrong')
            }
        }
        else {
            setisLoading(false);

            toast.error('Field cant empty')
        }
    }

    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            width: "10%"
        },
        {
            name: 'Type',
            selector: row => row.type,
            width: "40%"
        },
        {
            name: 'Date',
            selector: row => row.createdOn,
            width: "30%"
        },
        {
            name: 'Action',
            selector: row => row.action,
            width: "20%"
        }



    ];


    const getTypeOfCompanies = async () => {
        setisLoading(true);
        const res = await HttpClient.requestData("view-companyType", "GET", {});
        let apiData = []
        if (res && res?.status) {
            setisLoading(false);
            apiData = res?.data?.map((item, i) => ({

                sl: i + 1,
                type: item?.type,
                createdOn: moment(item?.createdOn).format("DD-MM-YYYY"),

                action: <EditDeleteIcon
                    onClickEdit={(e) => handleEdit(item)}
                    onClickDelete={(e) => handleDelete(item?._id)}
                />
            }));
        } else {
            setisLoading(false);
        }

        setAllData(apiData);
    }
    //Delete part 
    const handleDelete = (id) => {
        const del = async () => {
            setisLoading(true);
            const res = await HttpClient.requestData("delete-companyType/" + id, "DELETE")
            if (res && res?.status) {
                setisLoading(false);
                getTypeOfCompanies();

                toast.success("id Deleted Successfully");
            } else {
                setisLoading(false);
                toast.error(res?.message || "Something Wrong");
            }
        }

        DeleteConfirmModal(del);
    }
    //Edit
    const handleEdit = async (item) => {
        setisEdit(true)
        settypeOfCompanyID(item?._id)
        settypeOfCompany(item?.type)


    }
    //cancel edit
    const cancelEdit = (e) => {
        setisEdit(false)
        settypeOfCompany('')
        settypeOfCompanyID('')

    }
    // edit submit
    const handleEditSubmit = async (e) => {
        // console.log("valuesdd");
        e.preventDefault();

        if (!typeOfCompany) {
            toast.error('Input blank')
            return;
        }

        const data = {
            "type": typeOfCompany
        }
        setisLoading(true);
        const res = await HttpClient.requestData("update-companyType/" + typeOfCompanyID, "PUT", data);
        // console.log("resCat", res)
        if (res && res?.status) {
            toast.success("Added Successfully");
            setisEdit(false)
            settypeOfCompany('');

            setisLoading(false);
            getTypeOfCompanies()


        } else {
            toast.error(res?.message || "Something Wrong");
            setisLoading(false);

        }
    };

    useEffect(() => {
        getTypeOfCompanies();
    }, [])
    return (
        <div>

            <CustomLoader
                loading={isLoading}
            />


            <div className="d-flex justify-content-end">

                <div className="form-header">
                    <section className="piechartsBox_area">
                        <div
                            style={headLineStyle}
                            className="page-headline"
                        >
                            Type Of Company
                        </div>
                        <form>
                            <div className="row">



                                <div className="col-md-12 mt-3 ">
                                    <label htmlFor="formGroupExampleInput">Company Type<span className="text-danger">&nbsp;*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Company Type"
                                        name=""
                                        value={typeOfCompany}
                                        onChange={(e) => settypeOfCompany(e.target.value)}
                                    />
                                </div>




                            </div>





                            {/* Button */}
                            <div className="col-12 d-flex justify-content-end ">

                                {isEdit ? <div className=' d-flex '>
                                    <button
                                        type="submit"
                                        onClick={(e) => handleEditSubmit(e)}
                                        className="btn btn-primaryb mt-3 btn-grad"
                                    // style={{ background: "linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))", color: "#fff" }}
                                    >
                                        Update Data
                                    </button>
                                    <ImCross
                                        onClick={(e) => cancelEdit(e)}
                                        style={{ fontSize: "20px", cursor: "pointer" }} className=" mx-3 mt-4 text-danger " />
                                </div> : <button
                                    type="submit"
                                    onClick={(e) => handleSubmit(e)}
                                    className="btn btn-primaryb mt-3"
                                    style={{ background: "linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))", color: "#fff" }}
                                >
                                    Add Data
                                </button>}

                            </div>
                        </form>
                        <div className='mt-2'>

                            <DataTable
                                columns={columns}
                                data={AllData}
                                pagination
                                striped
                                className=" rounded mt-1"
                                customStyles={customStyles}
                            />
                        </div>

                    </section>
                </div>

            </div >




        </div >
    )
}

export default CompanyType